import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { HeartHandshake, Check, Clock } from "lucide-react";
import { useAccount, errMsg } from "@/lib/account";
import { usePrefs } from "@/lib/prefs";

export default function InterestButton({ pid }) {
  const { isSignedIn, authed, profile } = useAccount();
  const { t } = usePrefs();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  useEffect(() => { if (isSignedIn && profile) authed("get", `/interests/with/${pid}`).then(setSt).catch(() => {}); }, [pid, isSignedIn, profile, authed]);

  const send = async () => {
    if (!isSignedIn) return navigate("/sign-in");
    if (!profile) { toast.info("Create your profile first"); return navigate("/me"); }
    setBusy(true);
    try { const r = await authed("post", `/interests/${pid}`); setSt({ status: r.status, sent_by_me: true }); toast.success(r.status === "accepted" ? "Interest accepted — you can chat now" : "Interest sent"); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  const s = st?.status;
  if (s === "accepted") return <span data-testid="interest-status-accepted" className="flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-950/70 border border-emerald-500/40 text-emerald-300 text-sm"><Check className="w-4 h-4" /> {t("accepted")}</span>;
  if (s === "pending") return <span data-testid="interest-status-pending" className="flex items-center gap-2 px-5 py-3 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-200 text-sm"><Clock className="w-4 h-4" /> {st.sent_by_me ? t("sent") : "They're interested — see Interests"}</span>;
  if (s === "declined") return <span data-testid="interest-status-declined" className="px-5 py-3 rounded-full border border-slate-700 text-slate-400 text-sm">Not interested</span>;
  return (
    <button onClick={send} disabled={busy} data-testid="send-interest-button" className="btn-ghost px-6 py-3 rounded-full flex items-center gap-2">
      <HeartHandshake className="w-5 h-5" /> {t("sendInterest")}
    </button>
  );
}
